import { ReactComponent as ChevronDownSvg } from '../../assets/icons/chevron-down.svg';

export const ChevronDownIcon: SvgIcon = (props) => {
    return <ChevronDownSvg {...props} />;
};
